import { render, staticRenderFns } from "./tanghuay.vue?vue&type=template&id=e566a3aa&scoped=true&"
import script from "./tanghuay.vue?vue&type=script&lang=js&"
export * from "./tanghuay.vue?vue&type=script&lang=js&"
import style0 from "./tanghuay.vue?vue&type=style&index=0&id=e566a3aa&scoped=true&lang=css&"
import style1 from "./tanghuay.vue?vue&type=style&index=1&id=e566a3aa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e566a3aa",
  null
  
)

export default component.exports